export const LAST_UPDATED = "2026-07-14";

export const serviceRows = [
  {
    category: "스마트폰·기기",
    products: "최신 자급제폰, 박스폰, 태블릿, 스마트워치",
    help: "기기 상태와 예산에 맞는 단말기 선택",
  },
  {
    category: "모바일 요금제",
    products: "알뜰폰 유심 요금제, 이동통신사 약정 요금제",
    help: "사용량과 결합 조건을 고려한 요금제 선택",
  },
  {
    category: "인터넷·TV",
    products: "인터넷 및 TV 요금제",
    help: "모바일 회선과 함께 살펴보는 통신상품 가입",
  },
];

export const serviceSteps = [
  "필요한 스마트폰 단말기 또는 통신상품 종류를 정합니다.",
  "동네방네 공식 서비스에서 상품 상태, 요금, 약정과 지원 조건을 확인합니다.",
  "본인에게 맞는 상품을 선택한 뒤 화면의 안내에 따라 구매 또는 가입을 진행합니다.",
];

export const faqs = [
  {
    question: "동네방네는 어떤 서비스인가요?",
    answer:
      "동네방네는 스마트폰 단말기 구매와 유심·이동통신사 요금제, 인터넷·TV 가입을 한곳에서 살펴볼 수 있도록 돕는 통신생활 원스톱 서비스입니다.",
  },
  {
    question: "어떤 스마트폰과 통신상품을 살펴볼 수 있나요?",
    answer:
      "최신 자급제폰, 박스폰, 태블릿, 스마트워치와 알뜰폰 유심 요금제, 이동통신사 약정 요금제, 인터넷·TV 요금제를 살펴볼 수 있습니다.",
  },
  {
    question: "박스폰이란 무엇인가요?",
    answer:
      "동네방네에서 말하는 박스폰은 새 자급제폰과 할인 폭이 큰 민트급 미개통 자급제폰을 아우르는 단말기입니다. 실제 상태와 구성품은 각 상품의 안내를 확인해야 합니다.",
  },
  {
    question: "동네방네 서비스는 어떻게 이용하나요?",
    answer:
      "필요한 단말기나 통신상품을 정한 뒤 동네방네 공식 서비스에서 상품 상태, 요금, 약정과 지원 조건을 확인하고 화면 안내에 따라 구매 또는 가입하면 됩니다.",
  },
  {
    question: "표시된 가격과 가입 조건은 언제 확정되나요?",
    answer:
      "가격, 재고, 요금제와 지원 조건은 시점과 신청 조건에 따라 달라질 수 있습니다. 최종 결제 또는 가입 전에 동네방네 공식 서비스의 상품 상세와 신청 화면을 확인하세요.",
  },
];
